import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { xl: "12", lg: "12", md: "12", sm: "12", xs: "12" } },
            [
              _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { sm: "3", lg: "3" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          label: _vm.$t("my_tasks.tablas_tasks.name"),
                          dense: "",
                          outlined: "",
                          disabled: _vm.readonly,
                        },
                        model: {
                          value: _vm.page_add.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.page_add, "name", $$v)
                          },
                          expression: "page_add.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { sm: "4", lg: "4" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          label: _vm.$t("my_tasks.modals.description"),
                          dense: "",
                          outlined: "",
                          disabled: _vm.readonly,
                        },
                        model: {
                          value: _vm.page_add.description,
                          callback: function ($$v) {
                            _vm.$set(_vm.page_add, "description", $$v)
                          },
                          expression: "page_add.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "row", attrs: { sm: "3", lg: "3" } },
                    [
                      _c(
                        VBtn,
                        {
                          attrs: {
                            outlined: "",
                            small: "",
                            dense: "",
                            color: "secondary",
                          },
                          on: {
                            click: function ($event) {
                              _vm.$refs.imageInput.$el
                                .querySelector("input[type=file]")
                                .click()
                            },
                          },
                        },
                        [
                          _c(VIcon, { attrs: { small: "" } }, [
                            _vm._v("mdi-file-image"),
                          ]),
                          _vm._v(_vm._s(_vm.$t("my_tasks.modals.attach"))),
                        ],
                        1
                      ),
                      _c("b-form-file", {
                        ref: "imageInput",
                        staticStyle: { display: "none" },
                        attrs: { accept: _vm.METADATA_IMAGE_FORMAT.join(",") },
                        on: { change: _vm.onFileChangeImage },
                        model: {
                          value: _vm.inputUploadImage,
                          callback: function ($$v) {
                            _vm.inputUploadImage = $$v
                          },
                          expression: "inputUploadImage",
                        },
                      }),
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.page_add.preview
                                ? _vm.page_add.preview.fileName
                                : ""
                            )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { sm: "2", lg: "2" } },
                    [
                      !_vm.readonly
                        ? _c(
                            VBtn,
                            {
                              attrs: {
                                outlined: "",
                                color: "secondary",
                                rounded: "",
                                small: "",
                                dense: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onAddPage()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("btns.add_item")))]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "12", lg: "12" } },
                    [
                      _c(VDataTable, {
                        staticClass: "table-inca",
                        attrs: {
                          items: _vm.item.pages ? _vm.item.pages : [],
                          headers: [
                            {
                              value: "name",
                              text: _vm.$t("my_tasks.tablas_tasks.name"),
                            },
                            {
                              value: "description",
                              text: _vm.$t("my_tasks.modals.description"),
                            },
                            {
                              value: "preview",
                              text: _vm.$t("my_tasks.tablas_tasks.preview"),
                            },
                            {
                              value: "action",
                              text: _vm.$t("my_tasks.tablas_tasks.actions"),
                            },
                          ],
                          dense: "",
                          page: _vm.pagination.current,
                          "items-per-page": _vm.pagination.limit,
                          "hide-default-footer": true,
                        },
                        on: {
                          "update:page": function ($event) {
                            return _vm.$set(_vm.pagination, "current", $event)
                          },
                          pagination: function ($event) {
                            _vm.pagination.total = $event.itemsLength
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.preview",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                item.preview && item.preview.fileLink
                                  ? _c(
                                      VIcon,
                                      {
                                        attrs: { small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onClickLink(item.preview)
                                          },
                                        },
                                      },
                                      [_vm._v("mdi-file-image")]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "item.action",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(VBtn, {
                                  staticClass: "btn-icon-inca",
                                  attrs: { icon: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onRemovePage(item)
                                    },
                                  },
                                }),
                                _c(VIcon, { attrs: { small: "" } }, [
                                  _vm._v("icon-delete"),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("pagination-vue", {
                        attrs: { pagination: _vm.pagination },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-modal",
        { attrs: { id: _vm.MODAL_PREVIEW_FILE, "hide-footer": "" } },
        [
          _vm.currentFile && _vm.currentFile.fileLink
            ? _c("b-img", {
                staticClass: "imagepreview",
                staticStyle: { width: "100%" },
                attrs: { src: _vm.currentFile.fileLink },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }